// @flow
import { Text, View } from 'reshaped';

import type { OrderItem } from '@gandi/billing';
import { useTranslator } from '@gandi/translate';

export function Item({
  currency,
  item,
}: {
  currency: string,
  item: OrderItem,
}): React.MixedElement {
  const { formatPrice } = useTranslator();
  const attributes = { title: item.description };

  return (
    <View gap={4} direction="row" justify="space-between" align="center">
      <View.Item grow>
        <View gap={1}>
          <Text weight="medium" variant="body-2" attributes={{ ...attributes }}>
            {item.name_label}
          </Text>

          <Text variant="caption-1" color="neutral-faded">
            {item.description}
          </Text>
        </View>
      </View.Item>
      <View.Item>
        <Text as="p" variant="body-3" weight="bold">
          {formatPrice(item.price_before_taxes, currency)}
        </Text>
      </View.Item>
    </View>
  );
}
